import { render, staticRenderFns } from "./newDemandeDeCotationElec.vue?vue&type=template&id=19028567&"
import script from "./newDemandeDeCotationElec.vue?vue&type=script&lang=js&"
export * from "./newDemandeDeCotationElec.vue?vue&type=script&lang=js&"
import style0 from "./newDemandeDeCotationElec.vue?vue&type=style&index=0&id=19028567&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports